module.exports = __webpack_public_path__ + "static/media/speaker_head_expressions_face_front.b8a9a519.png";